import { createFileRoute } from "@tanstack/react-router";

import { DeviceSelectionPage } from "@/uiKit/pages/DeviceSelectionPage";

export const Route = createFileRoute("/")({
  component: DeviceSelectionPage,
});
